import { useSelector } from 'react-redux'
import { useAuth } from '../contexts/Auth'
import { selectUser } from '../redux/systemSlice'
import { FEATURE_FLAGS, usePricing } from './featureFlags'
import { useFeatureFlagVariantKey, usePostHog } from 'posthog-js/react'
import { useEffect, useState } from 'react'
import { logGoogleAdsEvent } from '../helpers/analytics'

const useCheckout = () => {
	const limitedTrialFF = useFeatureFlagVariantKey(FEATURE_FLAGS.LIMITED_TRIAL)
	const [referral, setReferral] = useState(null)
	const [loading, setLoading] = useState(false)
	const { currentUser } = useAuth() as any
	const user = useSelector(selectUser)
	const pricing = usePricing()
	const posthog = usePostHog()

	useEffect(() => {
		// Check to see if this is a redirect back from Checkout
		window.addEventListener('Rewardful.initialized', function () {
			// @ts-ignore
			setReferral(window.Rewardful.referral)
		})
	}, [])

	const checkout = async (annual: boolean) => {
		// `user` starts as NULL_USER ({ planId: null }), so it is truthy before the
		// account has loaded — check the ids the backend actually needs instead.
		if (!currentUser?.uid && !user?.id) return
		setLoading(true)
		posthog.capture('checkout-started', { annual })
		logGoogleAdsEvent('checkout')
		// if (usePaddle === 'test' && paddle) {
		// 	paddle.Checkout.open({
		// 		items: [
		// 			{
		// 				priceId: annual ? 'pri_01jfdrvvs5tcs8xr5xfdwda4wf' : 'pri_01jfdrdj0y2p0t588srvkme9pb',
		// 				quantity: 1,
		// 			},
		// 		],
		// 		customData: {
		// 			user_id: user.id,
		// 		},
		// 		settings: {
		// 			successUrl: window.location.href + `/?showModal=true${annual ? '&annual=true' : ''}`,
		// 			variant: 'one-page',
		// 		},
		// 	})
		// 	setLoading(false)
		// } else {
		const requestOptions = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				authorization: currentUser ? `Bearer ${await currentUser.getIdToken()}` : '',
			},
			body: JSON.stringify({
				uid: currentUser?.uid,
				userId: user?.id,
				humanizerUpgrade: false,
				price: annual ? pricing.stripePriceId.yearly ?? pricing.stripePriceId.monthly : pricing.stripePriceId.monthly,
				annual: annual,
				returnUrl: window.location.href,
				referral: referral,
				freeTrial: limitedTrialFF === 'test' ? true : false,
			}),
		}
		fetch(process['env']['REACT_APP_API_ROOT'] + '/payments/checkout/', requestOptions)
			.then((res) => res.json())
			.then((response: { url: string }) => {
				if (response.url) {
					setLoading(false)
					window.open(response.url, '_self')
				}
			})
			.catch((err) => {
				setLoading(false)
				console.error(err)
			})
		// }
	}

	return { checkout, loading }
}

export default useCheckout
